module.exports = __webpack_public_path__ + "static/img/dsk-products-bg.37c4781.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dsk-products-bg.jpg
// module id = 232
// module chunks = 1